import { DomainV2 } from 'troppus-common/domain';

import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

export type ToggleableRuleKind = 'normalizeKana' | 'normalizePhoneNumber';

// trim は string 型では applyTransformRulesToValue が常に適用するため UI 設定・transformRules には含めない。
export function toggleRuleKind(
  rules: ImportTableDefinition.SchemaJson.Column.TransformRule[],
  kind: ToggleableRuleKind,
  enabled: boolean,
): ImportTableDefinition.SchemaJson.Column.TransformRule[] {
  const rest = rules.filter((r) => r.kind !== kind);
  if (!enabled) return rest;
  return [...rest, { kind }];
}

export function hasRuleKind(rules: ImportTableDefinition.SchemaJson.Column.TransformRule[], kind: ToggleableRuleKind): boolean {
  return rules.some((r) => r.kind === kind);
}
